import { combineReducers } from 'redux';

import sporTotoCommonReducer from './sporTotoCommonReducer';
import sporTotoPopularSelectionsReducer from './sporTotoPopularSelectionsReducer';
import sporTotoCouponDetailsReducer from './sporTotoCouponDetailsReducer';
import sporTotoSelectionsReducer from './sporTotoSelectionsReducer';
import sporTotoSlipReducer from './sporTotoSlipReducer';
import sporTotoInfoReducer from './sporTotoInfoReducer';
import sporTotoCountDownReducer from './sporTotoCountDownReducer';

export default combineReducers({
  sporTotoCommonData: sporTotoCommonReducer,
  sporTotoPopularSelections: sporTotoPopularSelectionsReducer,
  sporTotoCouponDetails: sporTotoCouponDetailsReducer,
  sporTotoSelections: sporTotoSelectionsReducer,
  sporTotoSlip: sporTotoSlipReducer,
  sporTotoInfo: sporTotoInfoReducer,
  sporTotoCountDown: sporTotoCountDownReducer,
});
